export default __webpack_public_path__ + "static/media/deco-result2.380b2d3f.png";